// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"729d3d6f","787":"936f654d"}[chunkId] + ".chunk.js";
};